import { Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledFilter = styled(Box)(
  ({ theme }) => `
  `
);
export default StyledFilter;
